import script from "./BaseTablePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTablePagination.vue?vue&type=script&setup=true&lang=js"

import "./BaseTablePagination.vue?vue&type=style&index=0&id=12eaa6b4&lang=scss&scoped=true"
script.__scopeId = "data-v-12eaa6b4"

export default script